import Navigation from "../components/navigation";
import Footer from "../components/footer";
import HeadingTitle from "../pkg/components/heading-title";
import { companyName, navigation } from "../config/constants";
import Header from "../components/header";
import Main from "../pkg/components/main";
import LeadParagraph from "../pkg/components/lead-paragraph";

function Codex() {
	return (
		<>
			<Navigation companyName={companyName} navigation={navigation} />

			<Main>
				<Header>Codex</Header>

				<HeadingTitle>The Source of Truth</HeadingTitle>

				<LeadParagraph>
					Every enterprise runs on rules. Most are buried in code, documents, dashboards, and institutional memory. We surface them. 
					By defining business logic in a live ontology, we capture policy, process, regulation, and intent in one cohesive structure. 
					This is not a reference manual — it is the operational heartbeat. Systems read from it. People reason with it. Change it, and 
					everything downstream updates with precision.
				</LeadParagraph>
			</Main>

			<Footer />
		</>
	);
}

export default Codex;
